import { render, staticRenderFns } from "./EditPrimaryContactDialog.vue?vue&type=template&id=742a09a3"
import script from "./EditPrimaryContactDialog.vue?vue&type=script&lang=js"
export * from "./EditPrimaryContactDialog.vue?vue&type=script&lang=js"
import style0 from "./EditPrimaryContactDialog.vue?vue&type=style&index=0&id=742a09a3&prod&lang=stylus&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports